import React from 'react';
import { GetSocialTemplateProps } from '../interfaces';

export const GetSocialDefaultTemplate = (props: GetSocialTemplateProps) => {
  return (
    <div id={props.id} className={props.className}>
      <div className="get-social-content">
        <h2 className="get-social-header">Get Social</h2>
        <p className="get-social-insta">@waldo_vision</p>
        <div className="get-social-images-container">
          {props.slots.map((slot, key) => (
            <a
              className="get-social-link"
              key={key}
              href={props.hrefLink}
              target="_blank"
              rel="noreferrer"
            >
              <img className="get-social-image" src={slot.src} alt={slot.alt} />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
